import { useState } from "react";
import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import { Link } from "react-router-dom";

const plans = [
  {
    name: "Ücretsiz",
    monthlyPrice: 0,
    yearlyPrice: 0,
    desc: "Bireysel kullanım için ideal başlangıç",
    color: "border-gray-200",
    btnClass: "border-2 border-gray-300 text-gray-700 hover:bg-gray-50",
    features: [
      "5 QR Kod",
      "PNG İndirme",
      "Temel İstatistikler",
      "Statik QR Kodlar",
      "E-posta Desteği",
    ],
    missing: ["SVG & JPEG İndirme", "Dinamik QR Kodlar", "Ülke İstatistikleri", "Logo Ekleme"],
  },
  {
    name: "Pro",
    monthlyPrice: 149,
    yearlyPrice: 119,
    desc: "Büyüyen işletmeler için güçlü araçlar",
    color: "border-emerald-400",
    popular: true,
    btnClass: "bg-emerald-500 hover:bg-emerald-600 text-white",
    features: [
      "Sınırsız QR Kod",
      "PNG, SVG & JPEG İndirme",
      "Dinamik QR Kodlar",
      "Gerçek Zamanlı İstatistikler",
      "Ülke & Cihaz Analizi",
      "Logo Ekleme",
      "Öncelikli Destek",
    ],
    missing: ["Takım Üyeleri", "API Erişimi"],
  },
  {
    name: "Kurumsal",
    monthlyPrice: 399,
    yearlyPrice: 319,
    desc: "Büyük ekipler ve kurumsal ihtiyaçlar",
    color: "border-gray-200",
    btnClass: "bg-gray-900 hover:bg-gray-800 text-white",
    features: [
      "Sınırsız QR Kod",
      "Tüm Formatlar",
      "Dinamik QR Kodlar",
      "Gelişmiş Analitik",
      "Takım Üyeleri (10+)",
      "API Erişimi",
      "Özel Logo & Marka",
      "7/24 Öncelikli Destek",
      "SLA Garantisi",
    ],
    missing: [],
  },
];

export default function PricingPage() {
  const [yearly, setYearly] = useState(false);

  return (
    <div className="min-h-screen bg-gray-50">
      <Navbar />
      <div className="pt-16">
        <div className="max-w-6xl mx-auto px-6 py-16">
          {/* Header */}
          <div className="text-center mb-12">
            <span className="text-emerald-600 text-sm font-semibold uppercase tracking-widest">Fiyatlandırma</span>
            <h1 className="text-3xl md:text-4xl font-bold text-gray-900 mt-3 mb-4">
              Size Uygun Planı Seçin
            </h1>
            <p className="text-gray-500 max-w-xl mx-auto mb-8">
              Ücretsiz başlayın, büyüdükçe yükseltin. Tüm planlar 14 gün ücretsiz deneme içerir.
            </p>

            {/* Toggle */}
            <div className="inline-flex items-center gap-3 bg-white border border-gray-200 rounded-full px-2 py-1.5">
              <button
                onClick={() => setYearly(false)}
                className={`px-4 py-1.5 rounded-full text-sm font-semibold transition-all cursor-pointer whitespace-nowrap ${
                  !yearly ? "bg-emerald-500 text-white" : "text-gray-500"
                }`}
              >
                Aylık
              </button>
              <button
                onClick={() => setYearly(true)}
                className={`px-4 py-1.5 rounded-full text-sm font-semibold transition-all cursor-pointer whitespace-nowrap flex items-center gap-2 ${
                  yearly ? "bg-emerald-500 text-white" : "text-gray-500"
                }`}
              >
                Yıllık
                <span className={`text-xs px-1.5 py-0.5 rounded-full font-bold ${yearly ? "bg-white/20 text-white" : "bg-emerald-100 text-emerald-600"}`}>
                  %20 İndirim
                </span>
              </button>
            </div>
          </div>

          {/* Plans */}
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
            {plans.map((plan) => (
              <div
                key={plan.name}
                className={`relative bg-white rounded-2xl border-2 p-7 flex flex-col transition-all hover:scale-[1.01] ${plan.color}`}
              >
                {plan.popular && (
                  <div className="absolute -top-3.5 left-1/2 -translate-x-1/2 bg-emerald-500 text-white text-xs font-bold px-4 py-1 rounded-full whitespace-nowrap">
                    En Popüler
                  </div>
                )}

                <div className="mb-6">
                  <h3 className="text-lg font-bold text-gray-900">{plan.name}</h3>
                  <p className="text-sm text-gray-500 mt-1">{plan.desc}</p>
                </div>

                <div className="mb-6">
                  <div className="flex items-end gap-1">
                    <span className="text-4xl font-bold text-gray-900">
                      {plan.monthlyPrice === 0 ? "Ücretsiz" : `₺${yearly ? plan.yearlyPrice : plan.monthlyPrice}`}
                    </span>
                    {plan.monthlyPrice > 0 && (
                      <span className="text-gray-400 text-sm mb-1">/ay</span>
                    )}
                  </div>
                  {yearly && plan.monthlyPrice > 0 && (
                    <p className="text-xs text-emerald-600 mt-1">
                      Yıllık ₺{plan.yearlyPrice * 12} faturalandırılır
                    </p>
                  )}
                </div>

                <ul className="space-y-2.5 mb-6 flex-1">
                  {plan.features.map((f) => (
                    <li key={f} className="flex items-center gap-2.5 text-sm text-gray-700">
                      <i className="ri-check-line text-emerald-500 flex-shrink-0"></i>
                      {f}
                    </li>
                  ))}
                  {plan.missing.map((f) => (
                    <li key={f} className="flex items-center gap-2.5 text-sm text-gray-400">
                      <i className="ri-close-line text-gray-300 flex-shrink-0"></i>
                      {f}
                    </li>
                  ))}
                </ul>

                <Link
                  to="/generator"
                  className={`w-full flex items-center justify-center py-3 rounded-xl font-semibold text-sm transition-all cursor-pointer whitespace-nowrap ${plan.btnClass}`}
                >
                  {plan.monthlyPrice === 0 ? "Ücretsiz Başla" : "14 Gün Ücretsiz Dene"}
                </Link>
              </div>
            ))}
          </div>

          {/* FAQ */}
          <div className="mt-20">
            <h2 className="text-2xl font-bold text-gray-900 text-center mb-10">Sık Sorulan Sorular</h2>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6 max-w-4xl mx-auto">
              {[
                { q: "Ücretsiz planda kredi kartı gerekiyor mu?", a: "Hayır, ücretsiz plan için herhangi bir ödeme bilgisi gerekmez." },
                { q: "Dinamik QR kodları ne zaman kullanabilirim?", a: "Pro ve Kurumsal planlarda dinamik QR kodlar oluşturabilirsiniz." },
                { q: "İstediğim zaman iptal edebilir miyim?", a: "Evet, aboneliğinizi istediğiniz zaman iptal edebilirsiniz." },
                { q: "Oluşturduğum QR kodlar silinir mi?", a: "İptal sonrası 30 gün boyunca verileriniz korunur." },
              ].map((item) => (
                <div key={item.q} className="bg-white rounded-2xl border border-gray-100 p-5">
                  <h4 className="font-semibold text-gray-900 text-sm mb-2">{item.q}</h4>
                  <p className="text-sm text-gray-500">{item.a}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
}
